const PAX_TYPE = {
  LAP_INFANT: 'Infant in Lap',
  CHILD: 'Child',
  ADULT: 'Adult',
}

export { PAX_TYPE }
